import { CHART_TYPE } from 'xangle-charts'

import { UNIT } from '~/constants/default.constants'
import { ISeriesHelper, ITableHelper } from '~/types/chart-helper.type'

export const getSeriesHelperByApi = (api: string) => {
  const result: ISeriesHelper = {
    type: [ CHART_TYPE.LINE ],
    staking: '',
    unit: '',
    decimalPoint: 2,
    selectedPeriod: '1_all',
    wide: false,
  }
  // 날짜
  switch (api) {
    case '/analytics/overview/transaction':
    case '/analytics/token/burned':
    case '/analytics/network/avg-trx-address':
    case '/analytics/network/burned':
    case '/analytics/network/block-interval':
    case '/analytics/network/block-creation':
    case '/analytics/transaction-gas/transaction-fees':
    case '/analytics/transaction-gas/gas-used':
    case '/analytics/transaction-gas/average-gas-price':
    case '/analytics/valuation/marketcap-per-transaction':
    case '/analytics/valuation/marketcap-per-tvl':
    case '/analytics/valuation/rot':
    case '/analytics/valuation/psr':
      result.selectedPeriod = '6_month'
      break
    case '/analytics/user/new-addresses':
    case '/analytics/user/unique-addresses':
      result.selectedPeriod = '1_month'
      break
    case '/analytics/network/transaction':
      result.selectedPeriod = '7_day'
      break
  }
  // 차트 타입
  switch (api) {
    case '/analytics/network/tvl':
    case '/analytics/overview/tvl':
      result.type = [ CHART_TYPE.AREA ]
      break
    case '/analytics/token/trading-volume':
    case '/analytics/token/burned':
    case '/analytics/network/burned':
    case '/analytics/transaction-gas/transaction-fees':
    case '/analytics/transaction-gas/gas-used':
    case '/analytics/revenue/fee-revenue':
      result.type = [ CHART_TYPE.BAR ]
      break
  }
  // 유닛
  switch (api) {
    case '/analytics/token/price':
    case '/analytics/overview/price':
    case '/analytics/token/trading-volume':
    case '/analytics/network/tvl':
    case '/analytics/overview/tvl':
    case '/analytics/revenue/fee-revenue':
      result.unit = '$'
      break
    case '/analytics/token/circulating-supply':
    case '/analytics/token/burned':
    case '/analytics/network/burned':
    case '/analytics/transaction-gas/transaction-fees':
    case '/analytics/transaction-gas/average-gas-price':
    case '/analytics/transaction-gas/top-gas-spenders':
      result.unit = UNIT
      break
    case '/analytics/network/block-interval':
      result.unit = 'Sec.'
      break
  }
  // 와이드
  switch (api) {
    case '/analytics/key-market-indicator':
    case '/analytics/network/tvl':
    case '/analytics/user/active-addresses':
    case '/analytics/revenue/fee-revenue':
    case '/analytics/valuation/rot':
      result.wide = true
      break
  }
  // 소수점
  switch (api) {
    case '/analytics/valuation/psr':
      result.decimalPoint = 10
      break
  }
  return result
}

export const getTableHelperByApi = (api: string) => {
  const result: ITableHelper = {
    columnList: [],
    unit: '',
    wide: false,
  }
  switch (api) {
    case '/analytics/network/top-burners':
      result.columnList = [
        {
          text: 'Rank',
          value: 'RK',
          width: 50,
        },
        {
          text: 'Contract Address',
          value: 'LB',
        },
        {
          text: 'Gas Used',
          value: 'VAL',
          width: 100,
        },
      ]
      break
    case '/analytics/transaction-gas/top-gas-spenders':
      result.columnList = [
        {
          text: 'Rank',
          value: 'RK',
          width: 50,
        },
        {
          text: 'Address',
          value: 'LB',
        },
        {
          text: 'Gas Used',
          value: 'VAL',
          width: 100,
        },
      ]
      result.unit = UNIT
      break
  }
  return result
}